// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"cb525728","348":"10466486","558":"2126079c","571":"283c10d3"}[chunkId] + ".chunk.js";
};